// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"acdff398","265":"6a9a9f2d","298":"3621c889","382":"8fcaba6b","502":"b7eb355e"}[chunkId] + ".chunk.js";
};